import CrudTab from 'react/containers/pages/CrudTab';

class SeeLogs extends CrudTab {

  static tabName = 'DataImport.SeeLogs.erroTabTitle';

  componentDidMount() {
    const { key, data } = this.props.tab;
    this.router = new Greenmile.DataImport.SeeLogs();
    this.router.render(key, data);
  }

  componentDidUpdate() {
    const { active } = this.props;
    if (active && this.router) {
      this.router.getProgressAndErrors();
    }
  }

}

export default SeeLogs;
